import React, { useState } from "react";
import PropTypes from "prop-types";
import AddNewInputModal from "components/Metadata/AddNewInputModal";
import Translate from "helpers/Translate";

function AddField({ onSelectMenu }) {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div className="add-more-fields-wrapper">
      <button
        className="btn btn-default-light btn-full my-30"
        onClick={() => setShowMenu(!showMenu)}
      >
        <i className="fas fa-plus mr-5"></i>
        {Translate({ id: "add_field" })}
      </button>

      <div className="menu-container">
        <div className="inner">
          {showMenu && (
            <AddNewInputModal
              onSelectMenu={inputType => {
                setShowMenu(!showMenu);
                onSelectMenu({ inputType });
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

AddField.propTypes = {
  onSelectMenu: PropTypes.func.isRequired
};

export default AddField;
